<body>
  <div class="container">
    <div>
      <img src="../assets/WBD_Color_Warner Bros.png" width="12%" alt="Warner Bros. logo">
      <h2 class="title">Warner Bros. Studio Operations</h2>
      <h3 class="subtitle">GRIP ORDER FORM</h3>
    </div>
    <form #form="ngForm" [formGroup]="subscribeForm">
      <div class="detail-form">
        <table class="detail-table">
          <tr>
            <td style="display: flex;">
              <mat-form-field appearance="fill" id="formFields" class="left-input">
                <mat-label>Pull Date </mat-label>
                <input matInput required [matDatepicker]="picker2" [min]="minDate" [formControl]="pullDateCtrl"
                  name="pullDate">
                <mat-error *ngIf="pullDateCtrl.hasError('required')">
                  Pull date is <strong>required</strong>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="left-input" id="formFields">
                <mat-label>Equipment Return Date</mat-label>
                <input required matInput [matDatepicker]="picker0" [formControl]="returnDateCtrl" name="date">
                <mat-error *ngIf="returnDateCtrl.hasError('required')">
                  Return date is <strong>required</strong></mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
                <mat-datepicker #picker0></mat-datepicker>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill">
                <mat-label>Location</mat-label>
                <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5" matInput required [formControl]="locationCtrl" name="location"></textarea>
                <mat-error *ngIf="locationCtrl.hasError('required')">
                  Location is <strong>required</strong></mat-error>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td style="display: flex;">
              <mat-form-field id="formFields" appearance="fill" class="left-input">
                <mat-label>Rental Start and End Dates</mat-label>
                <mat-date-range-input required [rangePicker]="picker" [min]="minDate">
                  <input matStartDate placeholder="Start date" [formControl]="rentalStartCtrl">
                  <input matEndDate placeholder="End date" [formControl]="rentalReturnCtrl">
                </mat-date-range-input>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                  Rental range is <strong>required</strong>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill" class="left-input">
                <mat-label>Length of Rental</mat-label>
                <input required name="rentalLength" matInput [formControl]="lengthCtrl">
                <mat-error *ngIf="lengthCtrl.hasError('required')">
                  Length of Rental is <strong>required</strong></mat-error>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill">
                <mat-label>Show Name</mat-label>
                <input required [formControl]="showCtrl" matInput>
                <mat-error *ngIf="showCtrl.hasError('required')">
                  Show Name is <strong>required</strong></mat-error>
              </mat-form-field>
            </td>
            <td style="display: flex;">
              <mat-form-field id="formFields" appearance="fill" class="left-input">
                <mat-label>Ordered By</mat-label>
                <input matInput required [formControl]="requestorCtrl">
                <mat-error *ngIf="requestorCtrl.hasError('required')">
                  Ordered by Name is <strong>required</strong></mat-error>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill" class="left-input">
                <mat-label>Email</mat-label>
                <input required matInput [formControl]="emailFormControl" />
                <mat-error *ngIf="emailFormControl.hasError('email')">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="emailFormControl.hasError('required')">
                  Email is <strong>required</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill">
                <mat-label>Phone</mat-label>
                <input required [formControl]="phoneCtrl" matInput>
                <mat-error *ngIf="phoneCtrl.hasError('required')">
                  Phone number is <strong>required</strong></mat-error>
              </mat-form-field>
              <br>
            </td>
          </tr>
          <tr>
            <td style="display: flex;">
              <mat-radio-group style="margin:auto 50px auto 0px" id="formFields" required aria-label="Select an option"
                [formControl]="deliveryCtrl">
                <mat-radio-button style="margin-right:5px" value="Pick-up">Pick-up</mat-radio-button>
                <mat-radio-button value="Delivery">Delivery</mat-radio-button>
                <mat-error *ngIf="deliveryCtrl.hasError('required') && dataSource.length>0">
                  Selecting an option is <strong>required</strong>
                </mat-error>
              </mat-radio-group>
              <mat-form-field class="left-input" id="formFields" appearance="fill">
                <mat-label>Pick-up/Delivery Date</mat-label>
                <input required matInput [matDatepicker]="picker6" [formControl]="pickupDateCtrl" [min]="minDate">
                <mat-error *ngIf="emailFormControl.hasError('required')">
                  Pickup/Delivery date is <strong>required</strong>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                <mat-datepicker #picker6></mat-datepicker>
              </mat-form-field>
              <mat-form-field id="formFields" appearance="fill">
                <mat-label>Pick-up/Delivery Time</mat-label>
                <input required matInput type="time" format="hh:mm a" short-time="true" [formControl]="pickupTime">
                <mat-error *ngIf="pickupTime.hasError('required')">
                  Pickup/Delivery time is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field appearance="fill" class="left-input" id="formFields">
                <mat-label>Date</mat-label>
                <input required matInput [matDatepicker]="picker1" [min]="minDate" [formControl]="date" name="date">
                <mat-error *ngIf="date.hasError('required')">
                  Date is <strong>required</strong></mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="left-input" id="formFields">
                <mat-label>Comments</mat-label>
                <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5" matInput [formControl]="commentCtrl" name="comment"></textarea>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </div>
      <div class="item-form">
        <mat-form-field [floatLabel]="floatLabelControl.value" class="search-input">
          <input id="myInput" matInput placeholder="Search by part number or name" aria-label="Item"
            [matAutocomplete]="auto" [formControl]="stateCtrl">
          <mat-autocomplete #auto="matAutocomplete">
            <cdk-virtual-scroll-viewport class="autocomplete-test-viewport" itemSize="25"
              [ngStyle]="{'height': '200px'}">
              <mat-option [value]="item.partNumber + ' ' + '|'+' '+item.description"
                *cdkVirtualFor="let item of filteredItems">
                <span>{{item.partNumber}} | {{item.description}}</span>
              </mat-option>
            </cdk-virtual-scroll-viewport>
          </mat-autocomplete>
        </mat-form-field>
        <button mat-button (click)="add()" mat-stroked-button color="primary">Add Item</button>
        <mat-toolbar color="primary">Equipment List</mat-toolbar>
        <div *ngIf="dataSource.length === 0" class="detail-form mat-elevation-z8">No items selected</div>
        <table mat-table *ngIf="dataSource.length>0" [dataSource]="dataSource" matSort matSortActive="partName"
          matSortDirection="desc" #mytable class="my-table mat-elevation-z8">
          <thead>
            <!-- Id Column -->
            <ng-container matColumnDef="partNumber">
              <th scope="col" class="description" mat-header-cell *matHeaderCellDef>Equipment Code </th>
              <td mat-cell *matCellDef="let element">
                <p>{{element.partNumber}}</p>
              </td>
            </ng-container>
            <ng-container matColumnDef="partName">
              <th scope="col" class="description" mat-header-cell *matHeaderCellDef>Description </th>
              <td mat-cell *matCellDef="let element">
                <p>{{element.partName}}</p>
              </td>
            </ng-container>
            <!-- quantity Column -->
            <ng-container matColumnDef="qty">
              <th scope="col" class="detail-columns" mat-header-cell *matHeaderCellDef> Quantity </th>
              <td mat-cell *matCellDef="let element;let i=index">
                <mat-form-field class="dropdown-input">
                  <input matInput type="number" min="1" required [name]="element.qty + '_' + i"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="element.qty">
                </mat-form-field>
              </td>
            </ng-container>
            <!-- notes Column -->
            <ng-container matColumnDef="notes">
              <th scope="col" class="detail-columns" mat-header-cell *matHeaderCellDef> Notes </th>
              <td mat-cell *matCellDef="let element; let i=index" class="action-link">
                <mat-form-field class="notes">
                  <textarea cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5" matInput [name]="element.notes + '_' + i"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="element.notes"></textarea>
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let i = index;">
                <button class="remove-button" mat-button (click)="remove(i)">Remove</button>
              </td>
            </ng-container>
          </thead>
          <tbody>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </tbody>
        </table>
      </div>
      <div class="recaptcha-section">
        <re-captcha (resolved)="onCaptchaResolved($event)" id="recaptcha" name="recaptcha" #recaptcha="ngModel"
          [(ngModel)]="token" required [ngModelOptions]="{standalone: true}"
          [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
      </div>
      <br>
      <button [disabled]="!subscribeForm.valid || dataSource.length === 0 || !captchaVerified" class="submit-btn" mat-raised-button
        color="primary" name=”submit” type=”submit” (click)="register()">Submit
        Order</button>
    </form>
  </div>

</body>